import { canBypassLocalDevAuth } from './localDevAuthPolicy';

export const localDevAuthBypass = (): boolean =>
    canBypassLocalDevAuth(
        import.meta.env,
        typeof window === 'undefined' ? undefined : window.location.hostname,
    );
